module.exports = __webpack_public_path__ + "852979ada1dd0c853da021e6e0156e3a.svg";